import { ICON_NAMES, IconName, IconWeight, IIcon } from '../models/configs/icons/icons';

/**
 * FontAwesome icon name → icon name of the SVG sprites, for the FontAwesome glyphs of CS3 data
 * - FontAwesome aliases (e.g. `home` for `house`) need an own entry
 * - CS3 keeps FontAwesome (menu glyphs in the admin, provider glyphs, …), CS4 translates them when the data arrives
 */
export const FA_TO_ICON_NAME: Record<string, IconName> = {
  'angles-up-down': 'caret-up-down',
  archive: 'archive',
  'arrow-pointer': 'cursor',
  'arrow-progress': 'path',
  'arrow-right': 'arrow-right',
  'arrow-right-from-bracket': 'sign-out',
  'arrow-up-right-from-square': 'arrow-square-out',
  'arrows-down-to-line': 'arrow-line-down',
  'arrows-rotate': 'arrows-clockwise',
  'arrows-up-down': 'arrows-vertical',
  'arrows-up-down-left-right': 'arrows-out-cardinal',
  award: 'medal',
  bars: 'list',
  'basket-shopping': 'basket',
  bell: 'bell',
  'book-open': 'book-open',
  bookmark: 'bookmark',
  briefcase: 'briefcase',
  building: 'building',
  calculator: 'calculator',
  calendar: 'calendar',
  'calendar-check': 'calendar-check',
  'calendar-days': 'calendar-dots',
  'calendar-range': 'calendar-blank',
  'calendar-star': 'calendar-star',
  'cart-shopping': 'shopping-cart',
  'cash-register': 'cash-register',
  check: 'check',
  'chevron-down': 'caret-down',
  'chevron-left': 'caret-left',
  'chevron-right': 'caret-right',
  'chevron-up': 'caret-up',
  'circle-exclamation': 'warning-circle',
  'circle-info': 'info',
  'circle-minus': 'minus-circle',
  'circle-play': 'play-circle',
  'circle-xmark': 'x-circle',
  clipboard: 'clipboard',
  'clipboard-list': 'clipboard-text',
  'clipboard-list-check': 'list-checks',
  'clipboard-user': 'user-list',
  clock: 'clock',
  'clock-rotate-left': 'clock-counter-clockwise',
  close: 'x',
  code: 'code',
  'code-branch': 'git-branch',
  cog: 'gear',
  'coffin-cross': 'cross',
  'comments-o': 'chats',
  copy: 'copy',
  'credit-card': 'credit-card',
  crop: 'crop',
  cubes: 'cube',
  database: 'database',
  desktop: 'desktop',
  download: 'download-simple',
  edit: 'note-pencil',
  envelope: 'envelope',
  'envelope-circle-check': 'envelope-simple',
  'envelope-o': 'envelope',
  'envelope-open-text': 'envelope-open',
  'exclamation-triangle': 'warning',
  expand: 'arrows-out',
  eye: 'eye',
  'eye-slash': 'eye-slash',
  facebook: 'brand-facebook',
  'facebook-f': 'brand-facebook-f',
  'face-frown': 'smiley-sad',
  'face-smile': 'smiley',
  file: 'file',
  'file-certificate': 'certificate',
  'file-circle-check': 'file-text',
  'file-circle-info': 'file-text',
  'file-import': 'file-arrow-down',
  'file-invoice': 'receipt',
  'file-lines': 'file-text',
  files: 'files',
  filter: 'funnel',
  'floppy-disk': 'floppy-disk',
  'flower-daffodil': 'flower',
  folder: 'folder',
  'folder-grid': 'folders',
  'folder-image': 'images',
  'folder-magnifying-glass': 'folder-open',
  gear: 'gear',
  gears: 'gear-six',
  gift: 'gift',
  'gift-card': 'gift',
  globe: 'globe',
  heart: 'heart',
  home: 'house',
  house: 'house',
  'id-card': 'identification-card',
  image: 'image',
  'image-landscape': 'image',
  'image-portrait': 'user-rectangle',
  'images-user': 'images',
  import: 'download-simple',
  info: 'info',
  'info-circle': 'info',
  instagram: 'brand-instagram',
  key: 'key',
  language: 'translate',
  'layer-group': 'stack',
  link: 'link',
  'link-slash': 'link-break',
  linkedin: 'brand-linkedin',
  list: 'list',
  loader: 'spinner',
  'location-dot': 'map-pin',
  'location-pin': 'map-pin',
  lock: 'lock',
  'magnifying-glass': 'magnifying-glass',
  'magnifying-glass-location': 'map-trifold',
  'magnifying-glass-minus': 'magnifying-glass-minus',
  'magnifying-glass-plus': 'magnifying-glass-plus',
  'map-marker': 'map-pin',
  'map-pin': 'map-pin',
  message: 'chat-text',
  minus: 'minus',
  'minus-circle': 'minus-circle',
  mobile: 'device-mobile',
  newspaper: 'newspaper',
  'objects-align-bottom': 'align-bottom',
  'objects-align-center-horizontal': 'align-center-horizontal',
  'objects-align-center-vertical': 'align-center-vertical',
  'objects-align-left': 'align-left',
  'objects-align-right': 'align-right',
  'objects-align-top': 'align-top',
  paintbrush: 'paint-brush',
  palette: 'palette',
  'party-horn': 'confetti',
  paste: 'clipboard',
  pen: 'pen',
  'pen-to-square': 'note-pencil',
  pencil: 'pencil',
  'person-circle-question': 'question',
  'person-digging': 'hard-hat',
  phone: 'phone',
  pinterest: 'brand-pinterest',
  play: 'play',
  plus: 'plus',
  print: 'printer',
  question: 'question',
  'rectangle-code': 'code-block',
  'rectangle-vertical': 'device-tablet',
  'rectangle-wide': 'rectangle',
  'right-from-bracket': 'sign-out',
  'right-to-bracket': 'sign-in',
  'share-nodes': 'share-network',
  'shield-check': 'shield-check',
  shop: 'storefront',
  'shopping-basket': 'basket',
  'shopping-cart': 'shopping-cart',
  sliders: 'sliders',
  spinner: 'spinner',
  'spinner-third': 'circle-notch',
  'square-exclamation': 'warning-circle',
  'square-question': 'question',
  'square-xmark': 'x-square',
  star: 'star',
  'star-sharp': 'star',
  stethoscope: 'stethoscope',
  store: 'storefront',
  'table-cells-large': 'squares-four',
  tablet: 'device-tablet',
  tape: 'ruler',
  text: 'text-t',
  ticket: 'ticket',
  tiktok: 'brand-tiktok',
  'times-sign': 'x',
  trash: 'trash',
  'trash-can': 'trash',
  'trash-xmark': 'trash',
  'triangle-exclamation': 'warning',
  truck: 'truck',
  twitter: 'brand-twitter',
  upload: 'upload-simple',
  user: 'user',
  'user-check': 'user-check',
  'user-lock': 'lock',
  'user-minus': 'user-minus',
  'user-pen': 'user-gear',
  'user-plus': 'user-plus',
  users: 'users',
  utensils: 'fork-knife',
  'wand-magic-sparkles': 'magic-wand',
  warning: 'warning',
  whatsapp: 'brand-whatsapp',
  'wreath-laurel': 'medal',
  x: 'x',
  'x-twitter': 'brand-x-twitter',
  xing: 'brand-xing',
  xmark: 'x',
  youtube: 'brand-youtube'
};

/** Icon weight of a FontAwesome style */
const FA_TO_ICON_WEIGHT: Record<string, IconWeight> = {
  'fa-thin': 'thin',
  'fa-light': 'light',
  'fa-regular': 'regular',
  'fa-solid': 'fill',
  'fa-duotone': 'duotone',
  'fa-brands': 'regular'
};

/** Icon names of the SVG sprites, glyphs that are already one need no translation */
const ICON_NAME_SET = new Set<string>(ICON_NAMES);
/** FontAwesome names without translation that were already reported, to warn once per name */
const reportedUnmappedIcons = new Set<string>();

/** Icon as configs stored it with FontAwesome name and style */
export interface IFontAwesomeIcon {
  /** FontAwesome name, e.g. 'magnifying-glass' */
  name: string;
  /** FontAwesome style, e.g. 'fa-solid' */
  type: string;
  /** Optional animation for the icon */
  animation?: IIcon['animation'];
}

/**
 * Icon name of a FontAwesome glyph of CS3 data (menu glyphs, tabs, transaction types, dashboard)
 * @param glyph FontAwesome name or classes, e.g. "folder", "fa fa-folder fa-5x" or "fad fa-flower-daffodil"; icon names pass unchanged
 * @returns The icon name, undefined without glyph or translation
 */
export function iconNameFromFontAwesome(glyph: string | null | undefined): IconName | undefined {
  if (!glyph) return undefined;
  // First token that is no prefix ("fa", "fas", …), style or size ("fa-light", "fa-5x", …), e.g. "fa fa-folder fa-5x" → "folder"
  const name = glyph
    .split(/\s+/)
    .filter((token) => !/^fa[srbldt]?$/.test(token))
    .map((token) => token.replace(/^fa[srbli]?-/, ''))
    .find((token) => !/^(thin|light|regular|solid|duotone|brands|sharp|fw|2?xs|sm|lg|2?xl|\d+x)$/.test(token));
  if (!name) return undefined;
  if (ICON_NAME_SET.has(name)) return name as IconName;
  const iconName = FA_TO_ICON_NAME[name];
  if (!iconName && !reportedUnmappedIcons.has(name)) {
    reportedUnmappedIcons.add(name);
    console.warn(`[icons] No icon for the FontAwesome glyph "${glyph}", add it to FA_TO_ICON_NAME`);
  }
  return iconName;
}

/**
 * Translates the icons of a config that were saved with FontAwesome name and style (`{ name, type: 'fa-…' }`)
 * @param value Config or part of it, translated in place
 * @returns The same value
 */
export function convertFontAwesomeIcons<T>(value: T): T {
  if (!value || typeof value !== 'object') return value;
  for (const [key, entry] of Object.entries(value)) {
    if (isFontAwesomeIcon(entry)) {
      (value as Record<string, unknown>)[key] = {
        // Without translation the name stays, gs-icon then renders nothing and the warning names the glyph
        name: iconNameFromFontAwesome(entry.name) ?? (entry.name as IconName),
        weight: FA_TO_ICON_WEIGHT[entry.type] ?? 'light',
        animation: entry.animation
      } satisfies IIcon;
    } else {
      convertFontAwesomeIcons(entry);
    }
  }
  return value;
}

/**
 * Whether a value is an icon with FontAwesome name and style
 * @param value Any config value
 * @returns True for `{ name, type: 'fa-…' }`
 */
function isFontAwesomeIcon(value: unknown): value is IFontAwesomeIcon {
  const icon = value as IFontAwesomeIcon | null;
  return typeof icon?.name === 'string' && typeof icon.type === 'string' && icon.type.startsWith('fa-');
}
